import { Column, Row } from '../../../src/components/Grid';

import CardWithImageInArc from '../../../src/components/Card/CardWithImageInArc';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { translate } from 'react-i18next';
import useMobile from '../../../src/utils/useMobile';

const Root = styled.div`
  ${Column} {
    padding-left: ${props => props.theme.layout.gutter / 2}px;
    padding-right: ${props => props.theme.layout.gutter / 2}px;
  }
`;

const Title = styled.h3`
  font-family: ${props => props.theme.font.heading3.fontFamily};
  font-size: ${props => props.theme.font.heading3.fontSize};
  line-height: ${props => props.theme.font.heading3.lineHeight};
  color: ${props => props.theme.color.brand.accent};

  margin: ${props => props.theme.layout.gutter * 1.5}px 0
    ${props => props.theme.layout.gutter}px;
`;

const List = ({ label, id, items, categorySlug, t, i18n }) => {
  const { isMobile } = useMobile();

  const renderBrand = item => {
    const { slug, name, type, imgDesk, logoDesk2, is_new, is_heart } = item;

    const card = {
      title: name,
      image: {
        url: imgDesk,
        alt: name,
        width: isMobile ? 162 : 260,
        height: isMobile ? 162 : 260
      },
      logo: {
        url: logoDesk2,
        alt: name
      },
      link: `${t('common:brands.navigation.brands')}/${type}/${categorySlug ||
        'uncategorized'}/${slug}`
    };

    return (
      <Column key={item.id} mobile={2} tablet={3} desktop={4}>
        <CardWithImageInArc
          card={card}
          maxWidth={isMobile ? 162 : 260}
          minWidth={isMobile ? 162 : 260}
          fullHeight
          isNew={is_new}
          isHeart={is_heart}
        />
      </Column>
    );
  };

  const renderBrands = () => {
    return items.map(renderBrand);
  };

  return (
    <Root name={id}>
      <Title>{label}</Title>
      <Row space={10}>{renderBrands()}</Row>
    </Root>
  );
};

List.propTypes = {
  id: PropTypes.number.isRequired,
  label: PropTypes.string.isRequired,
  categorySlug: PropTypes.string.isRequired,
  items: PropTypes.array.isRequired,
  t: PropTypes.func.isRequired,
  i18n: PropTypes.object.isRequired
};

export default translate()(List);
